export default __webpack_public_path__ + "static/media/INQUIRY_POSITION.db40569c.png";